/**
 * 서버 ErrCode 중 "정상적으로 처리되는" 코드 목록.
 * UX(알림/리다이렉트/새로고침 등)로 이미 처리되는 분기이므로 Sentry Issue로 잡지 않는다.
 */
export const ERR_CODES = {
  SUCCESS: '00000000', // 성공
  CERT_SENT: '10010001', // 인증문자 발송 성공
  MVNO_REDIRECT: '00100305', // 알뜰폰 사용자 리다이렉트
  BLOCKED_USER: '10020022', // 차단 사용자 → 새로고침
  CERT_INVALID: '10020002', // 인증번호 오류
  CERT_EXCEEDED: '10020004', // 인증번호 횟수초과
  ALREADY_JOINED: '10020001', // 이미 가입됨
} as const

/** 정상 성공 응답 코드 — 실패 response breadcrumb 대상에서 제외한다 */
export const SUCCESS_ERR_CODES = new Set<string>([ERR_CODES.SUCCESS, ERR_CODES.CERT_SENT])
